import React from 'react';
import { EZoomErrorType } from 'types/zoom';
import { reportError } from 'api/zoom';

const useVideoAndAudioPermisson = (): [checked: boolean, allowVideo?: boolean, allowAudio?: boolean] => {
    const [checked, setChecked] = React.useState(false);
    const [allowVideo, setAllowVideo] = React.useState<boolean>();
    const [allowAudio, setAllowAudio] = React.useState<boolean>();
    const checkFun = async () => {
        try {
            // 请求权限
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

            // 能取到哪些 tracks，就表示已获哪些权限
            const hasVideo = stream.getVideoTracks().length > 0;
            const hasAudio = stream.getAudioTracks().length > 0;

            console.log({
                video: stream.getVideoTracks(),
                audio: stream.getAudioTracks(),
            });

            setAllowVideo(hasVideo);
            setAllowAudio(hasAudio);

            // 所有的 tracks 关闭掉，防止占用硬件
            stream.getTracks().forEach((track) => track.stop());
        } catch (err: any) {
            // 可能用户只拒绝了其中一个
            // 为了兼容各种设备和浏览器，这里分别测试 video 和 audio 权限

            // video
            console.error(err);
            try {
                let errStr: string = err;
                if (err.toString) {
                    errStr = err.toString();
                } else if (typeof err === 'object') {
                    errStr = JSON.stringify(err);
                }
                reportError({
                    errorCode: EZoomErrorType.PERMISSION_NOT_ALLOW,
                    message: errStr,
                });
            } catch (e: any) {
                console.error(err);
            }
            try {
                const videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
                setAllowVideo(true);
                videoStream.getTracks().forEach((track) => track.stop());
            } catch {
                setAllowVideo(false);
            }

            // audio
            try {
                const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
                setAllowAudio(true);
                audioStream.getTracks().forEach((track) => track.stop());
            } catch {
                setAllowAudio(false);
            }
        } finally {
            setChecked(true);
        }
    };
    React.useEffect(() => {
        checkFun();
    }, []);

    return [checked, allowVideo, allowAudio];
};

export default useVideoAndAudioPermisson;
